/**
 * Helpers of the addon page (ShoptetApplicationDetail, shared by the Shoptet, Upgates and
 * Eshop-rychle addons). Which ERP switches the page to the simplified template is defined by
 * SIMPLIFIED_ADDON_ERPS in UISettings.react.js (uiSettings.addonSimplified).
 */

// Test addons use the erp format 'test-{erp}' (e.g. 'test-peppos').
export function resolveAddonErp(erp?: string | null): string | null {
    if (!erp) {
        return null;
    }
    const lower = String(erp).toLowerCase();
    return lower.startsWith('test-') ? lower.slice(5) : lower;
}

/** The simplified template drops the "propose a solution" option unless no scenario exists. */
export function shouldShowProposeSolution(simplified: boolean | undefined, hasScenario: boolean): boolean {
    return !hasScenario || !simplified;
}

/**
 * Query string for the scenario installation opened from an addon (Shoptet, Upgates, Eshop-rychle).
 * The addon's own shop channel is preset with `skip,locked`: ScenarioApply uses it for the flow,
 * skips its wizard step and cannot switch to another shop channel of the organisation. When the
 * scenario has no group for that channel, ScenarioApply ignores the preset and shows the step.
 */
export function buildAddonInstallQuery(addonParam: string, channelRealId?: string | null): string {
    const parts: string[] = [];
    if (addonParam) {
        parts.push(addonParam);
    }
    if (channelRealId) {
        parts.push(`channel.eshop=id:${encodeURIComponent(channelRealId)},skip,locked`);
    }
    return parts.join('&');
}
